import { RhythmPortion } from "./rhythms/rhythm-types";

export class Counter {
    public beat: number = 0;
    public portionIndex: number = 0;

    constructor(private readonly track: RhythmPortion[]) {
        if (this.track.length === 0) throw new Error("no track portions");
    }

    updateTime = (time: number) => {
        var index = this.track.length - 1;
        while (index > 0 && this.track[index].startTime > time) {
            index--;
        }
        this.portionIndex = index; // check/event to limit updates?
        const portion = this.track[index];
        const delta = time - portion.startTime;
        if (delta < 0 || portion.beatsPerMinute === 0) {
            this.beat = 1;
            return;
        }

        const secondsPerBeat = 60.0 / portion.beatsPerMinute;
        this.beat = Math.floor(
            ((delta / secondsPerBeat) % portion.beatsPerCycle) + 1
        );
    };
}

export default Counter;
